import "./clientSettings.scss";

import { observer, useLocalObservable } from "mobx-react";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import { Menu } from "antd";
import type { MenuProps } from "antd";

const MenuOptions = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {}, []);

  const state = useLocalObservable(() => ({
    get menuItems() {
      const { dataStructure } = controller.clientSettingsModal;
      let items: MenuProps["items"] = Object.keys(dataStructure).map((value, index) => ({
        key: value,
        label: value,
        style: { color: "white" },
        className: "uppercase text-md font-bold",
      }));

      return items;
    },
  }));

  const { selectedOption } = controller.clientSettingsModal;
  return (
    <Menu
      theme="light"
      mode="inline"
      items={state.menuItems}
      selectedKeys={selectedOption}
      onClick={(e) => controller.setClientSettingsModal("selectedOption", e.key)}
      className="bg-blue-600 flex flex-wrap"
    />
  );
});

export default MenuOptions;
